<div class="flex items-center relative w-full">
  <div class="text-primary mr-2 flex items-center justify-center">
    <ng-container *ngIf="icon; else defaultIcon">
      <ng-icon [name]="icon" size="20"></ng-icon>
    </ng-container>
    <ng-template #defaultIcon>
      <img
        [src]="iconoSoles"
        alt="icono por defecto"
        class="w-5 h-10 object-contain"
      />
    </ng-template>
  </div>
  <input
    [type]="type"
    type="text"
    class="bg-transparent px-2 py-1 w-full outline-none"
    [placeholder]="placeholder"
    [(ngModel)]="searchTerm"
    (input)="filterOptions(); isOpen = true"
    (focus)="isOpen = true"
    (keydown)="handleInput($event)"
  />
  <div class="absolute right-2 cursor-pointer" (click)="toggleDropdown()">
    <svg class="w-4 h-4 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
      <path
        fill-rule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.06z"
        clip-rule="evenodd"
      />
    </svg>
  </div>
  <div
    class="absolute top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded shadow z-10 max-h-60 overflow-y-scroll"
    *ngIf="isOpen"
  >
    <div
      *ngFor="let option of filteredOptions"
      class="px-3 py-2 hover:bg-gray-100 cursor-pointer"
      (click)="chooseOption(option)"
    >
      {{ option.label }}
    </div>
    <!--
    @if(showAddOption){
    <div class="px-3 py-2 hover:bg-gray-50 text-gray-600 cursor-pointer border-t border-gray-100"
      (click)="chooseOption(searchTerm)">
      Agregar "{{ searchTerm }}"
    </div>
    }-->
  </div>
</div>
